import { Suspense, useEffect } from "react"

import { Loading, useCurrentView } from "web/components"
import { useObjectList } from "web/hooks/data"

import Header from "./Header"
import TopicSection from "./TopicSection"

function TopicLocationCardLoading() {
  return (
    <div className="mb-4 h-full w-64 cursor-pointer rounded-md bg-white pb-2 shadow-altrio-1">
      <Loading delay={0} inline={true} />
    </div>
  )
}

function TopicLocationCard({
  subjectType,
  topic,
  location,
  records,
  onItemClick,
  onSelectionChanged,
  subject,
  onClose,
}) {
  return (
    <div className="mb-4 h-full w-64 cursor-pointer rounded-md bg-white pb-2 shadow-altrio-1">
      <Header
        title={subject.name}
        location={location}
        selectionEnabled={false}
        onClose={onClose}
      />
      <div
        className="overflow-auto"
        style={{ maxHeight: "calc(100% - 150px)" }}
      >
        {records.map((record, i) => (
          <TopicSection
            key={i}
            subjectType={subjectType}
            topic={topic}
            data={record}
            showToggle={false}
            isExpanded={true}
            selectionEnabled={true}
            onSelectionChanged={onSelectionChanged}
            onClick={() => onItemClick(record, records)}
          />
        ))}
      </div>
    </div>
  )
}

function TopicLocationCardWithFetch({
  subjectType,
  topic,
  records,
  onItemClick,
  onSelectionChanged,
  location,
  onClose,
}) {
  const recordIds = records.map((r) => r.id)
  const selection = records.filter((r) => r.selected).map((r) => r.id)

  const { view } = useCurrentView()

  const { detail: fetchedRecords } = useObjectList({
    subjectType,
    topic: topic.id,
    ids: recordIds,
    view: view,
  })

  for (const record of fetchedRecords) {
    record.selected = selection.includes(record.id)
  }

  function refreshRecords() {
    fetchedRecords.refresh()
  }

  useEffect(() => {
    document.addEventListener(
      "event-dispatcher:refresh-object-list",
      refreshRecords
    )
    return () =>
      document.removeEventListener(
        "event-dispatcher:refresh-object-list",
        refreshRecords
      )
  })

  const record = fetchedRecords[0]

  return (
    <TopicLocationCard
      subjectType={subjectType}
      topic={topic}
      location={location}
      subject={record}
      records={fetchedRecords}
      onItemClick={onItemClick}
      onSelectionChanged={onSelectionChanged}
      onClose={onClose}
    />
  )
}

export default function TopicLocationCardWrapper(props) {
  return (
    <Suspense fallback={<TopicLocationCardLoading />}>
      <TopicLocationCardWithFetch {...props} />
    </Suspense>
  )
}
